import React from "react";
import { Form, DatePicker, Mentions, Button } from 'antd';
import moment from 'moment';
import Widget from '../../Components/Theme/Widget';


const FormItem = Form.Item;

 class DayTypeCalendarForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
        };
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
            }
        });
       this.props.handleCalendarFormSubmit()
    };


    render() {
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 24},
            },
        };

            return (

                <Form onSubmit={this.handleSubmit}>

                    <FormItem
                        {...formItemLayout}
                    >
                        <div>
                            <Mentions  style={{ marginRight: 10, border: "none", width: 120 }} placeholder="Start Date" readOnly/>
                            <DatePicker
                                onChange={this.props.handleStartDateChange}
                                defaultValue={moment().startOf('year')}
                                required
                                popupStyle={{ zIndex: 2000 }}
                            />
                        </div>
                    </FormItem>

                    <FormItem {...formItemLayout}>
                        <Button type="submit" block size={'small'} htmlType="submit">Submit</Button>
                    </FormItem>

                </Form>
            );
    }
}

export const WrappedDayTypeCalendarForm = Form.create()(DayTypeCalendarForm);




// WEBPACK FOOTER //
// ./src/Components/DayType/DayTypeCalendarForm.js